import React from 'react';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Card as PrimeCard } from 'primereact/card';

import '../pages/frontPricing.scss';

export default function FrontPrimeCard({
  title,
  description,
  price,
  priceText,
  priceId,
  checklistP,
  buttonLabel,
  disable,
  icon,
  headerStyle,
  priceStyle,
  keyFeatures,
  period,
  allCard,
}) {
  const history = useHistory();

  return (
    <div className="card_item padding_0">
      <PrimeCard className={[disable ? 'Inactive' : 'Active', title === 'Branded Digital Network' ? 'borderEnterprise' : '']}>
        <div className="card_top_conatiner flex flex-column align-items-center">
          <div>
            <img alt="icon" src={icon} />
          </div>
          <div className={headerStyle}>
            <span>{title}</span>
          </div>
          <div className="card-underHeader">
            {description.map(d => (
              <p className="description" key={d}>
                {d}
              </p>
            ))}
          </div>
        </div>
        <div className={priceStyle}>
          <span>{priceText || 'Loading...'}</span>
        </div>
        <Button
          className="btn-magenta"
          disabled={disable || !priceText}
          label={buttonLabel}
          onClick={() => {
            if (buttonLabel === 'Get started') {
              history.push('/checkout', { data: { allCard, selected: { title, price, priceText, icon, checklistP, priceId } } });
            } else {
              window.open('https://www.upshow.tv/get-a-demo/', '_blank');
            }
          }}
        />
        {period === '1' && buttonLabel === 'Get started' && (
          <a href="https://www.upshow.tv/get-a-demo/" className="small-demo">
            Or Book a Demo
          </a>
        )}
        <div className="bottom_container flex flex-column">
          <div id="text-mark">
            <div className="pi">
              <div className="keyFeature"> {keyFeatures} </div>
              {checklistP.map(check => (
                <div key={check} className="textmark">
                  <div className="check_list align-items-center">
                    <i className="pi pi-check p-mr-2" />
                    <p>{check}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div>
            {period === '1-3' && title !== 'Branded Digital Network' ? (
              <a href="https://www.upshow.tv/get-a-demo/" target="_blank" className="link" rel="noreferrer">
                Learn More
              </a>
            ) : null}
          </div>
        </div>
      </PrimeCard>
    </div>
  );
}

FrontPrimeCard.propTypes = {
  checklistP: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  priceText: PropTypes.string.isRequired,

  buttonLabel: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  keyFeatures: PropTypes.string.isRequired,
  disable: PropTypes.bool,
  headerStyle: PropTypes.string,
  priceStyle: PropTypes.string,
  priceId: PropTypes.string,
  period: PropTypes.string.isRequired,
  allCard: PropTypes.array.isRequired,
  price: PropTypes.number,
};

FrontPrimeCard.defaultProps = {
  headerStyle: 'card-header',
  priceStyle: 'card-price',
  disable: false,
  priceId: undefined,
  price: undefined,
};
